import { useRef } from "react";
import { motion, useMotionValue, useTransform, useReducedMotion } from "framer-motion";

const NODES = [
  [80, 120], [260, 60], [470, 140], [700, 80], [920, 150], [1150, 90],
  [160, 330], [400, 300], [640, 380], [880, 320], [1120, 360],
  [100, 560], [330, 520], [580, 600], [840, 540], [1100, 590],
  [220, 760], [500, 800], [780, 740], [1040, 790],
];

const EDGES = [
  [0, 1], [1, 2], [2, 3], [3, 4], [4, 5],
  [0, 6], [1, 7], [2, 7], [2, 8], [3, 8], [4, 9], [5, 10],
  [6, 7], [7, 8], [8, 9], [9, 10],
  [6, 11], [7, 12], [8, 13], [9, 14], [10, 15],
  [11, 12], [12, 13], [13, 14], [14, 15],
  [11, 16], [12, 17], [13, 17], [13, 18], [14, 19], [15, 19],
  [16, 17], [17, 18], [18, 19],
];

const ACTIVE = [1, 8, 14, 22, 30, 12, 25];

const NetworkBackground = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const px = useTransform(mx, [-0.5, 0.5], [-22, 22]);
  const py = useTransform(my, [-0.5, 0.5], [-14, 14]);

  const onMove = (e) => {
    if (reduce || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };

  return (
    <div ref={ref} onMouseMove={onMove} className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 grid-lines opacity-60" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,#07131F_78%)]" />
      <motion.div className="absolute -inset-10" style={reduce ? {} : { x: px, y: py }}>
        <svg viewBox="0 0 1200 860" preserveAspectRatio="xMidYMid slice" className="h-full w-full">
          {EDGES.map(([a, b], i) => (
            <line
              key={i}
              x1={NODES[a][0]} y1={NODES[a][1]} x2={NODES[b][0]} y2={NODES[b][1]}
              stroke="#18B7A0"
              strokeOpacity={ACTIVE.includes(i) ? 0.35 : 0.12}
              strokeWidth="1"
              strokeDasharray={ACTIVE.includes(i) ? "6 18" : undefined}
              className={ACTIVE.includes(i) ? "animate-dash-flow" : undefined}
            />
          ))}
          {NODES.map(([x, y], i) => (
            <g key={i}>
              <circle cx={x} cy={y} r="10" fill="#18B7A0" opacity="0.05" />
              <circle
                cx={x} cy={y} r={i % 5 === 0 ? 3 : 2}
                fill={i % 7 === 0 ? "#D6B56A" : "#18B7A0"}
                className="animate-node-pulse"
                style={{ animationDelay: `${(i % 9) * 0.4}s` }}
              />
            </g>
          ))}
        </svg>
      </motion.div>
    </div>
  );
};

export default NetworkBackground;
